@if (isAdmin) {
    <af-faq-admin (hasDataListener)="hasDataListener.emit($event)"
                  (addQuestionClickListener)="addQuestionClickListener.emit()"/>
} @else {
    <div fxLayout="column" fxLayoutAlign="start start" class="w-100 h-100">
        <div class="w-100 overflow-y-scroll mt-16" fxFlex>
            <af-knowledge-base-categories/>
        </div>
    </div>
}
